import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import { getDevData } from "../../services/generalService";
import { ChargeObj } from "../../utils/types";

const initialState: ChargeObj = {
  data: null,
  isLoading: true,
  isSuccess: false,
  isError: false,
};

export const getChargeDetails = createAsyncThunk(
  "loans/getChargeDetails",
  async (url: string, thunkAPI) => {
    try {
      const data = await getDevData(url);
      return data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error?.response?.data);
    }
  }
);

const chargeGetSlice = createSlice({
  name: "charges",
  initialState,
  reducers: {
    // synchronous aperations goes here
  },
  extraReducers: (builder) => {
    builder
      .addCase(getChargeDetails.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getChargeDetails.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.data = action.payload;
      })
      .addCase(getChargeDetails.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.data = null;
      });
  },
});

export default chargeGetSlice.reducer;
